import LegalDoc from "@/components/legal/LegalDoc";

export default function Terms() {
  return <LegalDoc kind="terms" />;
}
